import { FunctionComponent } from 'react'
import { styled } from '@mui/material'
import { Box, Typography } from '@mui/material'
import CardsSection, { Props as CardsSectionProps } from './CardsSection'

const GlobalContainer = styled(Box)({
  margin: '0 auto',
  maxWidth: '62.125rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
})

const MainHeader = styled(Box)({
  textAlign: 'center',
})

const MainHeading = styled(Typography)({
  fontSize: '2.25rem',
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: '2.5rem',
})

export type Config = CardsSectionProps[]

export type Props = {
  title: string
  config: Config
}

const Landing: FunctionComponent<Props> = ({ config, title }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <MainHeader>
        <GlobalContainer>
          <MainHeading mt={4} variant="h1">
            {title}
          </MainHeading>
        </GlobalContainer>
      </MainHeader>
      {config.map((conf) => {
        return (
          conf &&
          conf.cards.length > 0 && (
            <Box mb={4}>
              <GlobalContainer>
                <CardsSection key={conf.title} {...conf} />
              </GlobalContainer>
            </Box>
          )
        )
      })}
    </Box>
  )
}
export default Landing
